export enum LevelType {
  NONE,
  STORE,
  TUTORIAL_OPPONENT,
  OPPONENT,
  BOSS,
}

export enum ActionTrigger {
  ENTER_EVENT,
  EXIT_EVENT,
  ITEM_USED,
  PRE_SPIN,
  SPINNING,
  RESULT,
  POST_RESULT,
}

export abstract class LevelAction {
  constructor(public readonly triggerType: ActionTrigger) {}

  public abstract Run(): void;
}

export interface LevelActionWithWeight {
  action: LevelAction;
  weight: number;
}

export class Level {
  name: string = "";
  icon: string = "";
  bigIcon: string = "";
  description: string = "";
  soundtrack: string = "";
  levelType: LevelType = LevelType.NONE;
  actions: LevelAction[] = [];
}

export class StoreLevel extends Level {
  constructor() {
    super();
    this.levelType = LevelType.STORE;
    this.icon = "icon_shop";
  }
}

export class OpponentLevel extends Level {
  requiredScore: number = 0;
  rewardMoney: number = 2;
  constructor() {
    super();
    this.levelType = LevelType.OPPONENT;
    this.icon = "icon_opponent";
  }
}

export class TutorialLevel extends OpponentLevel {
  constructor() {
    super();
    this.levelType = LevelType.TUTORIAL_OPPONENT;
    this.rewardMoney = 5;
    this.icon = "icon_opponent";
  }
}

export class BossLevel extends OpponentLevel {
  difficultyLevel: number = 1;
  constructor() {
    super();
    this.levelType = LevelType.BOSS;
    this.rewardMoney = 5;
    this.icon = "icon_boss";
  }
}
